import { render, staticRenderFns } from "./IconDeviceTabletSolid.vue?vue&type=template&id=231e6bc6"
import script from "./IconDeviceTabletSolid.vue?vue&type=script&lang=js"
export * from "./IconDeviceTabletSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports